import React, { Component } from 'react';
import { func, object } from 'prop-types';
import moment from 'moment';

import AppointmentButton from '../AppointmentButton';

import s from './AppointmentRequest.css';


export default class AppointmentRequest extends Component {
  static propTypes = {
    authenticatedPreferences: object,
    closeAlertDialog: func,
    closeConfirmDialog: func,
    getUpcomingAppointments: func,
    handleGetFilterLabels: func,
    handleRequestAppointment: func,
    hideFullPageLoadingState: func,
    openConfirmDialog: func,
    openSuccessDialog: func,
    resetSchedulingUi: func,
    request: object,
    showFullPageLoadingState: func,
  };

  constructor(props) {
    super(props);

    // Practice level setting(s)
    this.appointmentSchedulingApproveMode = this.props.authenticatedPreferences.appointmentSchedulingApproveMode;
  }

  submitAppointmentRequest = (e) => {
    e.preventDefault();

    const okCallback = () => {

      this.props.closeConfirmDialog();
      this.props.showFullPageLoadingState();

      // The passed appointment request object is broken down and passed in as a new data object for the call.
      const request = this.props.request;
      const item1 = request.selectedFirstValue;
      const item2 = request.selectedSecondValue;
      const item3 = request.selectedThirdValue;
      const item4 = request.selectedFourthValue;
      const date = request.selectedDate;
      const slot = request.slot;
      const notes = request.notes;
      const message = this.buildAppointmentRequestMessage();
      const data = {
        item1,
        item2,
        item3,
        item4,
        date,
        slot,
        notes,
      };

      const successCallback = response => {

        this.props.hideFullPageLoadingState();
        this.props.getUpcomingAppointments();

        this.props.openSuccessDialog({
          title: response.message,
          content: message,
          okCallback: this.handleDialogClose,
        });

      };

      // Make the call
      this.props.handleRequestAppointment(data, successCallback);

    };

    this.props.openConfirmDialog({
      title: 'Please confirm your appointment details.',
      content: this.buildAppointmentRequestMessage(),
      cancelCallback: this.props.closeConfirmDialog,
      okCallback,
    });

  };

  // Displays request summary above AppointmentButton and renders in the success Dialog
  buildAppointmentRequestMessage = () => {
    const { selectedDate, slot } = this.props.request;
    const duration = slot.duration;
    const time = slot.start;
    const hours = time / 60;
    const minutes = time % 60;
    const convertedDay = moment(selectedDate).format('dddd');
    const convertedMonth = moment(selectedDate).format('MMM DD');
    const convertedTime = moment(selectedDate).hour(hours).minutes(minutes).format('h:mm A');

    if (this.appointmentSchedulingApproveMode === 'request') {
      return (
        <span>
          You are requesting an appointment on {convertedDay}, {convertedMonth} at {convertedTime} for {duration} minutes. Click OK to confirm.
        </span>
      );
    }
    else if (slot) {
      return (
        <span>
          Your appointment requested on {convertedDay}, {convertedMonth} at {convertedTime} for {duration} minutes is approved.
        </span>
      );
    } else {
      // let's return a fail handler
      return (
        <span>
          There was an error creating your appointment request summary.
          Please review the above information before submitting.
        </span>
      );
    }

  };

  // Close success dialog, getFilterLabels, refresh parent state
  handleDialogClose = () => {

    this.props.resetSchedulingUi();
    this.props.closeAlertDialog();
    this.props.handleGetFilterLabels();

  };

  render = () =>
    <nav className={s.component}>
      <form
        id="requestAppointmentForm"
        onSubmit={this.submitAppointmentRequest}
      >
        <AppointmentButton
          text="Request Appointment"
          disabled={!this.props.request.slot}
        />
      </form>
    </nav>;
}



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentRequest/AppointmentRequest.js